const { mergeReplacingArrays } = require('../utils')
const { isUUID, isSimpleObject } = require('../validators')

function $defaulter(value, { $default }) {
  if (value !== undefined) {
    if (Array.isArray(value)) {
      return value
    }
    if (isSimpleObject(value)) {
      return mergeReplacingArrays({}, $default, value)
    }
  }

  return $default
}
exports.$defaulter = $defaulter

const isArrayOfUUIDs = value => Array.isArray(value) && value.filter(isUUID)
exports.isArrayOfUUIDs = isArrayOfUUIDs
